import { ICaseNoPrincipal } from '../types/caseNoPrincipal';

export const groupCaseNoPrincipalsToCsv = (data: ICaseNoPrincipal[]) => {
    //
    const groupData: any = [['#', 'Case Number', 'Student', 'Service Type']];
    data.forEach((it) => {
        let title = '';
        title = it?.serviceType?.title;
        if (!title) {
            title = it?.serviceType?.cpt;
        }

        groupData.push([
            it.id ? it.id : '',
            it.caseNumber ? it.caseNumber : '',
            it.student ? `${it.student.firstName} ${it.student.lastName}` : '',
            title,
        ]);
    });

    return groupData;
};
